export default __webpack_public_path__ + "static/media/settingsHC.b4e20dfa.svg";